import { InputHTMLAttributes, ReactNode, Ref, forwardRef } from 'react';
import { twMerge as cn } from 'tailwind-merge';

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  disabled?: boolean;
  label?: ReactNode | undefined;
}

// TODO: Quitar el texto default cuando no hay label, debería estar puesto en donde se necesita
const Checkbox = (
  { className, label, disabled, ...checkboxRestProps }: Props,
  ref: Ref<HTMLInputElement>,
) => {
  const disabledStyles = 'opacity-50 text-neutral-200';

  return (
    <div className={cn('flex items-start gap-x-2', className, disabled ? disabledStyles : null)}>
      <input
        ref={ref}
        disabled={disabled}
        id={checkboxRestProps.id}
        type="checkbox"
        className="form-checkbox rounded-sm text-primary focus:ring-primary"
        {...checkboxRestProps}
      />
      {label ? (
        <label htmlFor={checkboxRestProps.id} className="text-sm cursor-pointer flex-1">
          {label}
        </label>
      ) : (
        <label htmlFor={checkboxRestProps.id} className="text-sm cursor-pointer flex-1">
          He leído y acepto los{' '}
          <a href="/docs/citipremia-terminos.pdf" className="underline" target="_blank">
            términos y condiciones del programa
          </a>
          , así como el{' '}
          <a href="/aviso-privacidad" className="underline" target="_blank">
            Aviso de privacidad
          </a>{' '}
          de Citicinemas
        </label>
      )}
    </div>
  );
};

export default forwardRef<HTMLInputElement, Props>(Checkbox);
